import { ChatOutlinedIcon } from "../../ui/appIcons";
import { useChat } from "./ChatProvider";

export function ChatFab() {
  const { isOpen, setIsOpen, unreadBadge, setActiveConversationId } = useChat();
  const hasUnread = unreadBadge > 0;

  return (
    <div className={`chat-fab${hasUnread ? " chat-fab--pulse" : ""}`}>
      <button
        type="button"
        className="chat-fab__button"
        aria-label={isOpen ? "סגור צ׳אט" : "פתח צ׳אט"}
        title="הודעות"
        onClick={() => {
          if (isOpen) {
            setIsOpen(false);
            setActiveConversationId(null);
          } else {
            setIsOpen(true);
          }
        }}
      >
        <ChatOutlinedIcon />
        {hasUnread ? (
          <span className="chat-fab__badge">{unreadBadge > 99 ? "99+" : unreadBadge}</span>
        ) : null}
      </button>
    </div>
  );
}
